import React from "react";
import { iconProps } from "../Helper";

const ArrowBackIcon = ({className}:iconProps) => {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"

    >
      <path
        className={className}
        d="M10.4986 13.0958L0.921875 6.99981L10.4986 0.903809V13.0958ZM8.99863 10.3498V3.64981L3.72938 6.99981L8.99863 10.3498Z"
        fill="white"
      />
    </svg>
  );
};

export default ArrowBackIcon;
